import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/settings/user-management/')({
  loader: ({ params }) => {
    throw redirect({ to: '/org/$org/settings/user-management/users', params: { org: params.org } });
  },
});
